import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const ServicesSection = styled.section`
  padding: 100px 0;
  background: #0a0a0a;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const SectionTitle = styled(motion.h2)`
  font-family: "Playfair Display", serif;
  font-size: clamp(2.5rem, 5vw, 4rem);
  text-align: center;
  color: #ffffff;
  margin-bottom: 4rem;

  span {
    color: #ffd700;
  }
`;

const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 40px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const ServiceCard = styled(motion.div)`
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 3rem;
  border-radius: 20px;
  border: 1px solid rgba(255, 215, 0, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-10px);
    border-color: rgba(255, 215, 0, 0.5);
    box-shadow: 0 20px 40px rgba(255, 215, 0, 0.1);
  }
`;

const ServiceIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 1.5rem;
`;

const ServiceTitle = styled.h3`
  font-family: "Playfair Display", serif;
  font-size: 1.8rem;
  color: #ffd700;
  margin-bottom: 1rem;
`;

const ServiceDescription = styled.p`
  color: #b0b0b0;
  line-height: 1.8;
  font-size: 1.1rem;
`;

const Services = () => {
  const services = [
    {
      id: 1,
      icon: "🎯",
      title: "Personalized Learning",
      description:
        "AI-powered curriculum tailored to your goals and learning style",
    },
    {
      id: 2,
      icon: "🗣️",
      title: "Native Pronunciation",
      description:
        "Master perfect accents with real-time feedback and voice analysis",
    },
    {
      id: 3,
      icon: "👑",
      title: "VIP Tutoring",
      description:
        "1-on-1 sessions with elite language coaches and native speakers",
    },
  ];

  return (
    <ServicesSection id="services">
      <Container>
        <SectionTitle
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Our <span>Premium Services</span>
        </SectionTitle>
        <ServicesGrid>
          {services.map((service, index) => (
            <ServiceCard
              key={service.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <ServiceIcon>{service.icon}</ServiceIcon>
              <ServiceTitle>{service.title}</ServiceTitle>
              <ServiceDescription>{service.description}</ServiceDescription>
            </ServiceCard>
          ))}
        </ServicesGrid>
      </Container>
    </ServicesSection>
  );
};

export default Services;
